import { styled, Toolbar } from '@mui/material'

import { appBarHeight } from '@shared/constants'

export const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  justifyContent: 'space-between',
  height: appBarHeight.xs,
  minHeight: appBarHeight.xs + 'px' + '!important',
  [theme.breakpoints.up('md')]: {
    height: appBarHeight.md,
    minHeight: appBarHeight.md,
  },
}))
